export default __webpack_public_path__ + "1956c9438b931e1bdc09b4c3419075f9.png";